var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M14.302 1.139h-.23a.569.569 0 0 1 0-1.139h3.362a2.077 2.077 0 0 1 1.458 3.558c.61.44 1.027 1.117 1.027 1.898 0 1.29-1.173 2.355-2.485 2.355H14.87a.569.569 0 0 1-.568-.569V1.14zm-2.547 5.564l-.477-1.09a.571.571 0 0 1-.103.009h-3.04l-.028-.001-.467 1.07a.57.57 0 0 1-.141 1.12H6.227a.569.569 0 0 1 0-1.139h.18L9.173.342a.568.568 0 0 1 1.042 0l2.767 6.33h.227a.569.569 0 0 1 0 1.139h-1.271a.569.569 0 0 1-.184-1.108zm-3.15-2.22h2.18L9.695 1.99l-1.09 2.493zm-5.866.36L3.93 3.65a.568.568 0 1 1 .805.805l-1.19 1.192 1.19 1.192a.57.57 0 0 1-.804.805L2.74 6.452 1.548 7.644a.568.568 0 1 1-.805-.805l1.191-1.192-1.19-1.192a.57.57 0 0 1 .804-.805l1.19 1.192zM.57 11a.569.569 0 0 1 0-1.138H20.43a.569.569 0 0 1 0 1.138H.57zm16.865-4.327c.708 0 1.348-.581 1.348-1.217 0-.694-.75-1.3-1.546-1.3H15.44v2.517h1.995zm0-3.655a.939.939 0 0 0 0-1.88h-1.995v1.88h1.995z", id: "svg3158154221a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(0 5)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg3158154221b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg3158154221a" })
      ),
      React.createElement("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#svg3158154221a" }),
      React.createElement(
        "g",
        { mask: "url(#svg3158154221b)" },
        React.createElement("path", { d: "M0-2h22v15H0z" })
      )
    )
  );
});